import React, { useState, useEffect } from 'react'
import Logo from '@/assets/logo.svg'
import SupayLogo from '@/assets/supay_logo.svg'
import { Link } from 'gatsby'
const HEADER_HEIGHT = 80

export default function Header(): JSX.Element {
  const [isActive, setIsActive] = useState<boolean>(false)

  const toggleMenu = () => {
    setIsActive(!isActive)
  }

  useEffect(() => {
    if (isActive) {
      backFaceFixed(true)
    } else {
      backFaceFixed(false)
    }
  }, [isActive])

  useEffect(() => {
    const els = document.querySelectorAll('.pc-header__menu-link')
    els.forEach((el: Element) => {
      if (el.id === location.pathname.split('/')[1]) {
        el.classList.add('pc-header__menu-link--active')
      }
    })

    const mediaQuery = window.matchMedia('screen and (max-width: 1047px)')
    const checkBreakPoint = (e: any) => {
      if (e.matches) {
        spHeaderMenuEvent()
      } else {
        if (isActive) setIsActive(false)
        pcHeaderMenuEvent()
      }
    }

    try {
      mediaQuery.addEventListener('change', checkBreakPoint)
    } catch {
      mediaQuery.addListener(checkBreakPoint)
    }

    checkBreakPoint(mediaQuery)
  })

  const backFaceFixed = (fixed: boolean) => {
    const scrollingElement = (): Element | null => {
      const browser = window.navigator.userAgent
      if ('scrollingElement' in document) return document.scrollingElement
      if (browser.indexOf('webkit') > 0) return document.body
      return document.documentElement
    }

    const scrollY = fixed
      ? scrollingElement()!.scrollTop
      : parseInt(document.body.style.top || '0')

    const navi = document.querySelector('.header-nav--active') as HTMLElement
    const height = window.innerHeight - HEADER_HEIGHT

    if (navi) {
      navi.style.height = `${height}px`
    }

    const styles: any = {
      height: '-webkit-fill-available',
      left: '0',
      overflow: 'hidden',
      position: 'fixed',
      top: `${scrollY * -1}px`,
      width: '100vw',
    }

    Object.keys(styles).forEach((key: any) => {
      document.body.style[key] = fixed ? styles[key] : ''
    })

    if (!fixed) window.scrollTo(0, scrollY * -1)
  }

  const pcHeaderMenuEvent = () => {
    const parents = document.querySelectorAll('.parent')
    const companyMenu = document.querySelector(
      '.pc-header__company-sub-menu'
    ) as HTMLElement
    const options = {
      attributes: true,
      attributeFilter: ['class'],
    }
    const elements = []

    elements.push(companyMenu)

    for (const el of elements) {
      if (!el) return
    }

    parents.forEach((el: Element) => {
      el.addEventListener('mouseover', () => {
        if (el.lastElementChild) {
          const childMenu = el.lastElementChild as HTMLElement
          const childMenuList = childMenu.firstElementChild as HTMLElement

          childMenu.classList.add('menu-active')
          childMenuList.classList.add('menu-inner-active')
        }
      })

      el.addEventListener('mouseleave', () => {
        if (el.lastElementChild) {
          const childMenu = el.lastElementChild as HTMLElement
          const childMenuList = childMenu.firstElementChild as HTMLElement

          setTimeout(() => {
            childMenu.classList.remove('menu-active')
            childMenuList.classList.remove('menu-inner-active')
          }, 1000)
        }
      })
    })
  }

  const spHeaderMenuEvent = () => {
    const companyMenu = document.querySelector('.sp-company') as HTMLElement
    const recruitMenu = document.querySelector('.sp-recruit') as HTMLElement
    const elements = []
    const observer = []
    const options = {
      attributes: true,
      attributeFilter: ['open'],
    }

    elements.push(companyMenu)
    elements.push(recruitMenu)

    for (const el of elements) {
      if (!el) return
    }

    observer[0] = new MutationObserver(() => {
      if (
        recruitMenu.hasAttribute('open') &&
        companyMenu.hasAttribute('open')
      ) {
        recruitMenu.removeAttribute('open')
      }
    })

    observer[1] = new MutationObserver(() => {
      if (
        companyMenu.hasAttribute('open') &&
        recruitMenu.hasAttribute('open')
      ) {
        companyMenu.removeAttribute('open')
      }
    })

    for (let i = 0; i < elements.length; i++) {
      if (elements[i] !== null) observer[i].observe(elements[i], options)
    }
  }

  return (
    <>
      <header className="header">
        <div className="pc-header">
          <div>
            <Link to="/">
              <Logo className="pc-header__logo-image" />
            </Link>
          </div>
          <nav className="pc-header__menu">
            <ul className="pc-header__menu-list">
              <li className="pc-header__menu-list-item">
                <Link
                  className="pc-header__menu-link"
                  to="/shops/index_map/"
                  id="shops"
                >
                  店舗検索
                </Link>
              </li>
              <li className="pc-header__menu-list-item parent">
              <a
                  className="pc-header__menu-link"
                  href="https://trial-holdings.inc/company/"
                  target="_blank"
                  rel="noreferrer noopener"
                  id="company"
                >
                  会社情報
                </a>
                <div className="pc-header__company-sub-menu">
                  <div className="pc-header__company-sub-menu-inner">
                    <ul className="pc-header__company-sub-menu-list">
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://trial-holdings.inc/company/topmessage/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          ご挨拶
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://trial-holdings.inc/legal/code/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          行動規範
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://trial-holdings.inc/business/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          事業内容
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://trial-holdings.inc/news/video/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          戦略紹介動画
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://trial-holdings.inc/company/overview/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          会社概要
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://trial-holdings.inc/company/history/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          沿革
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          // href="https://trial-holdings.inc/company/overview/"
                          href="https://trial-holdings.inc/public-notice/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          電子公告
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://trial-holdings.inc/company/access/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          アクセス
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://trial-holdings.inc/business/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          トライアルグループ
                        </a>
                      </li>
                      <li className="pc-header__company-sub-menu-list-item">
                        <a
                          className="pc-header__company-sub-menu-link"
                          href="https://www.retail-ai.jp/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          Retail AI Technology
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li className="pc-header__menu-list-item">
                <a
                  className="pc-header__menu-link"
                  href="https://trial-holdings.inc/news/release/"
                  target="_blank"
                  rel="noreferrer noopener"
                  id="topics"
                >
                  お知らせ
                </a>
              </li>
              <li className="pc-header__menu-list-item">
                <a
                  href="https://trial-holdings.inc/careers/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="pc-header__menu-link"
                  id="recruit"
                >
                  採用情報
                </a>
              </li>
              <li className="pc-header__menu-list-item">
                <a
                  href="https://trial-holdings.inc/news/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="pc-header__menu-link"
                  id="media"
                >
                  ニュースルーム
                </a>
              </li>
              <li className="pc-header__menu-list-item">
                <a
                  href="https://www.trial-net.co.jp/mag/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="pc-header__menu-link"
                  id="magazine"
                >
                  トライアルマガジン
                </a>
              </li>
              <li className="pc-header__menu-list-item">
                <a
                  href="https://shopify.trial-net.co.jp/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="pc-header__menu-link"
                  id="onlineshop"
                >
                  トライアルネットストア
                </a>
              </li>
            </ul>
            <ul className="pc-header__prepaid-menu-list">
              <li className="pc-header__prepaid-menu-list-item">
                <Link
                  className="pc-header__menu-link"
                  to="/prepaid/"
                  id="prepaid"
                >
                  プリペイドカード
                </Link>
              </li>
              <li className="pc-header__prepaid-menu-list-item">
                <a
                  href="https://prepaid.su-pay.jp/regist/registPointSecond.html?goRegist=1"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="pc-header__menu-link"
                  id="balance"
                >
                  残高照会
                </a>
              </li>
              <li>
                <a
                  href="https://su-pay.jp/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <button className="pc-header__supay">
                    <SupayLogo className="pc-header__supay-logo-image" />
                  </button>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="sp-header">
          <div>
            <Link to="/">
              <Logo className="sp-header__logo-image" />
            </Link>
          </div>
          <div
            className={isActive ? 'hamburger-menu--active' : 'hamburger-menu'}
            onClick={toggleMenu}
          >
            <span className="hamburger-menu__line" />
            <span className="hamburger-menu__line" />
            <span className="hamburger-menu__line" />
          </div>
        </div>
      </header>
      <div className={isActive ? 'header-nav--active' : 'header-nav'}>
        <nav className="header-nav__menu">
          <ul className="header-nav__menu-list">
            <li className="header-nav__menu-list-item">
              <Link to="/shops/index_map/" className="header-nav__menu-link">
                店舗検索
              </Link>
            </li>
            <li className="header-nav__menu-list-item">
              <details className="header-nav__menu-accordion sp-company">
                <summary className="header-nav__menu-link">会社情報</summary>
                <ul className="header-nav__menu-accordion-list">
                  <li>
                    <a
                      href="https://trial-holdings.inc/company/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      トップ
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://trial-holdings.inc/company/topmessage/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      ご挨拶
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://trial-holdings.inc/legal/code/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      行動規範
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://trial-holdings.inc/business/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      事業内容
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://trial-holdings.inc/news/video/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      戦略紹介動画
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://trial-holdings.inc/company/overview/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      会社概要
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://trial-holdings.inc/company/history/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      沿革
                    </a>
                  </li>
                  <li>
                    <a
                      // href="https://trial-holdings.inc/company/overview/"
                      href="https://trial-holdings.inc/public-notice/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      電子公告
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://trial-holdings.inc/company/access/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      アクセス
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://trial-holdings.inc/business/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      トライアルグループ
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.retail-ai.jp/"
                      target="_blank"
                      rel="noreferrer noopener"
                      className="header-nav__menu-accordion-item"
                    >
                      Retail AI Technology
                    </a>
                  </li>
                </ul>
              </details>
            </li>
            <li className="header-nav__menu-list-item">
              <a
                href="https://trial-holdings.inc/careers/"
                target="_blank"
                rel="noreferrer noopener"
                className="header-nav__menu-link"
              >
                採用情報
              </a>
            </li>
            <li className="header-nav__menu-list-item">
              <a
                href="https://trial-holdings.inc/news/"
                target="_blank"
                rel="noreferrer noopener"
                className="header-nav__menu-link"
              >
                ニュースルーム
              </a>
            </li>
            <li className="header-nav__menu-list-item">
              <a
                href="https://www.trial-net.co.jp/mag/"
                target="_blank"
                rel="noreferrer noopener"
                className="header-nav__menu-link"
              >
                トライアルマガジン
              </a>
            </li>
            <li className="header-nav__menu-list-item">
              <a
                href="https://shopify.trial-net.co.jp/"
                target="_blank"
                rel="noreferrer noopener"
                className="header-nav__menu-link"
              >
                トライアルネットストア
              </a>
            </li>
          </ul>
          <ul className="header-nav__menu-list">
            <li className="header-nav__menu-list-item">
              <Link to="/prepaid/" className="header-nav__menu-link">
                プリペイドカード
              </Link>
            </li>
            <li className="header-nav__menu-list-item">
              <a
                href="https://prepaid.su-pay.jp/regist/registPointSecond.html?goRegist=1"
                target="_blank"
                rel="noreferrer noopener"
                className="header-nav__menu-link"
              >
                残高照会
              </a>
            </li>
          </ul>
          <a
            href="https://su-pay.jp/"
            target="_blank"
            rel="noreferrer noopener"
          >
            <button className="header-nav__menu-button">
              <SupayLogo className="header-nav__supay-img" />
            </button>
          </a>
          <ul className="header-nav__sub-menu-list">
            <li className="header-nav__sub-menu-list-item">
              <Link to="/faq/" className="header-nav__menu-link">
                よくあるご質問
              </Link>
            </li>
            <li className="header-nav__sub-menu-list-item">
              <a
                href="https://trial-holdings.inc/news/release/"
                target="_blank"
                rel="noreferrer noopener"
                className="header-nav__menu-link"
              >
                お知らせ
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </>
  )
}
